import React from 'react';

import './style/SearchBriefings.scss';
import { Button } from 'evergreen-ui';

const SearchBriefings = () => (
	<div className="search-briefings">
		<label htmlFor="search">Buscador:</label>

		<input type="text" id="search" />

		<Button content="Buscar" className="is-danger btn-search" />
	</div>
);

export default SearchBriefings;
